var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLighthouse = function SvgLighthouse(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 800,
    height: 800,
    preserveAspectRatio: "xMidYMid",
    viewBox: "0 0 256 256"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "lighthouse_svg__c",
    x1: "49.994%",
    x2: "49.994%",
    y1: ".226%",
    y2: "99.725%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#212121",
    stopOpacity: 0.04
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "66%",
    stopColor: "#212121",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "lighthouse_svg__i",
    x1: "36.626%",
    x2: "64.01%",
    y1: "20.358%",
    y2: "100.652%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "lighthouse_svg__j",
    x1: "68.935%",
    x2: "31.065%",
    y1: "65.756%",
    y2: "35.799%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#262626",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#262626",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "lighthouse_svg__k",
    x1: "62.531%",
    x2: "24.779%",
    y1: "13.086%",
    y2: "100.996%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#262626",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#262626",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "lighthouse_svg__l",
    x1: "0%",
    x2: "100%",
    y1: "50%",
    y2: "50%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#262626",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#262626",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "lighthouse_svg__p",
    x1: "49.994%",
    x2: "49.994%",
    y1: ".226%",
    y2: "99.725%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#212121",
    stopOpacity: 0.04
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "66%",
    stopColor: "#212121",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("path", {
    id: "lighthouse_svg__a",
    d: "M53.483 15.73h-7.645C42.598 6.56 33.866 0 23.594 0 10.57 0 0 10.57 0 23.594s10.57 23.597 23.594 23.597h29.889c8.686-.004 15.727-7.045 15.73-15.732-.004-8.686-7.044-15.726-15.73-15.73"
  }), /*#__PURE__*/React.createElement("path", {
    id: "lighthouse_svg__d",
    d: "M29.887 0H0v31.459h29.887c8.685-.004 15.725-7.044 15.729-15.73C45.612 7.045 38.572.005 29.886 0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "lighthouse_svg__g",
    d: "m.72.72 12.756 40.284c4.26-4.28 10.838-10.178 10.838-16.69C24.314 11.29 13.744.72.72.72"
  }), /*#__PURE__*/React.createElement("path", {
    id: "lighthouse_svg__n",
    d: "M61.71 18.15h-8.822C49.151 7.568 39.078 0 27.225 0 12.197 0 0 12.197 0 27.225S12.197 54.45 27.225 54.45h34.484c10.02 0 18.152-8.13 18.152-18.15 0-10.018-8.133-18.15-18.152-18.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "lighthouse_svg__q",
    d: "M34.484 0H0v36.3h34.484c10.02 0 18.152-8.132 18.152-18.15C52.636 8.13 44.503 0 34.484 0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "lighthouse_svg__t",
    d: "m.445.445 14.719 46.483C20.084 41.99 27.67 35.184 27.67 27.67 27.67 12.642 15.473.445.445.445"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "lighthouse_svg__h",
    cx: "10.105%",
    cy: "14.269%",
    r: "144.565%",
    fx: "10.105%",
    fy: "14.269%",
    gradientTransform: "matrix(.68182 0 0 1 .032 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "lighthouse_svg__m",
    cx: "14.489%",
    cy: "14.584%",
    r: "99.973%",
    fx: "14.489%",
    fy: "14.584%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "lighthouse_svg__u",
    cx: "10.105%",
    cy: "14.269%",
    r: "144.568%",
    fx: "10.105%",
    fy: "14.269%",
    gradientTransform: "matrix(.68181 0 0 1 .032 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("filter", {
    id: "lighthouse_svg__f",
    width: "159.3%",
    height: "134.8%",
    x: "-29.7%",
    y: "-12.4%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    "in": "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    "in": "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "shadowBlurOuter1",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "lighthouse_svg__s",
    width: "151.4%",
    height: "130.1%",
    x: "-25.7%",
    y: "-10.8%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    "in": "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    "in": "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "shadowBlurOuter1",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 127.777,
    cy: 127.777,
    r: 127.777,
    fill: "#0535C1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.363 58.08h75.505v75.505h-75.505z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(158.51 73.81)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "lighthouse_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#lighthouse_svg__a"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#lighthouse_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#EAEAEA",
    d: "M53.483 15.73h-7.645C42.598 6.56 33.866 0 23.594 0 10.57 0 0 10.57 0 23.594s10.57 23.597 23.594 23.597h29.889c8.686-.004 15.727-7.045 15.73-15.732-.004-8.686-7.044-15.726-15.73-15.73"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillOpacity: 0.2,
    d: "M69.212 31.649v-.19c-.003-8.686-7.043-15.726-15.729-15.73h-7.867v.393h7.867c8.609.001 15.617 6.92 15.73 15.529z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#lighthouse_svg__c)",
    d: "M77.312 47.19H23.594l22.26-31.46z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(23.594 15.73)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "lighthouse_svg__e",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#lighthouse_svg__d"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#lighthouse_svg__e)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-.72 -16.45)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#lighthouse_svg__g",
    fill: "#000",
    filter: "url(#lighthouse_svg__f)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#lighthouse_svg__g",
    fill: "#E1E1E1"
  })))), /*#__PURE__*/React.createElement("circle", {
    cx: 23.594,
    cy: 23.594,
    r: 23.594,
    fill: "#EEE"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillOpacity: 0.2,
    d: "M23.594.392c12.962 0 23.486 10.461 23.597 23.407v-.187C47.19 10.587 36.619.015 23.594.015 10.57.015 0 10.57 0 23.595v.189C.109 10.853 10.633.392 23.594.392"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#212121",
    fillOpacity: 0.1,
    d: "M53.483 46.796H23.594C10.635 46.796.111 36.336 0 23.392v.19c0 13.024 10.57 23.593 23.594 23.593h29.889c8.686-.003 15.726-7.043 15.73-15.729v-.187c-.109 8.61-7.118 15.536-15.73 15.54z"
  }))), /*#__PURE__*/React.createElement("path", {
    fill: "url(#lighthouse_svg__h)",
    d: "M211.993 89.54h-7.644c-3.241-9.17-11.973-15.73-22.244-15.73-13.025 0-23.595 10.57-23.595 23.594s10.57 23.597 23.595 23.597h29.888c8.687-.004 15.727-7.045 15.73-15.732-.004-8.685-7.044-15.726-15.73-15.73"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF176",
    d: "M92.929 53.725h66.792v58.08H92.93z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M85.667 142.295h79.86v79.86h-79.86z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F4481E",
    d: "M174.24 105.997h11.615v23.23H69.696v-23.23h11.615V59.53l46.466-29.039 46.463 29.04zm-23.233 0v-33.59l-23.23-14.516-23.233 14.517v33.589z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F4481E",
    d: "m64.536 238.83 19.68-132.835h87.12l19.679 132.836c-18.646 10.641-40.232 16.72-63.238 16.72-23.007 0-44.593-6.079-63.24-16.72m89.253-92.758-54.655 17.76-6.643 44.833 67.33-21.88-6.032-40.715z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#lighthouse_svg__i)",
    d: "m174.129 129.227 16.237 109.604c-18.646 10.641-40.232 16.72-63.238 16.72-23.007 0-44.593-6.079-63.24-16.72l16.238-109.604h-10.43v-23.23h11.615V59.53l46.466-29.039 46.463 29.04v46.465h11.615v23.23H174.13"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#lighthouse_svg__j)",
    d: "M127.777 105.997H81.31V59.53l46.466-29.039z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#lighthouse_svg__k)",
    d: "M127.777 255.551a127.7 127.7 0 0 1-63.24-16.72l14.56-109.604h48.678v126.324z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#lighthouse_svg__l)",
    d: "M69.696 105.997h58.08v23.232h-58.08z",
    transform: "matrix(-1 0 0 1 197.473 0)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 127.777,
    cy: 127.777,
    r: 127.777,
    fill: "url(#lighthouse_svg__m)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.589 82.764h87.12v87.12h-87.12z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(31.217 100.913)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "lighthouse_svg__o",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#lighthouse_svg__n"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#lighthouse_svg__o)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FAFAFA",
    d: "M61.71 18.15h-8.822C49.151 7.568 39.078 0 27.225 0 12.197 0 0 12.197 0 27.225S12.197 54.45 27.225 54.45h34.484c10.02 0 18.152-8.13 18.152-18.15 0-10.018-8.133-18.15-18.152-18.15"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillOpacity: 0.2,
    d: "M79.86 36.519V36.3c0-10.02-8.132-18.152-18.15-18.152h-9.074v.455h9.073c9.933 0 18.02 7.983 18.152 17.915"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#lighthouse_svg__p)",
    d: "M89.206 54.45H27.225l25.683-36.3z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(27.225 18.15)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "lighthouse_svg__r",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#lighthouse_svg__q"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#lighthouse_svg__r)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-.445 -18.594)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#lighthouse_svg__t",
    fill: "#000",
    filter: "url(#lighthouse_svg__s)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#lighthouse_svg__t",
    fill: "#E1E1E1"
  })))), /*#__PURE__*/React.createElement("circle", {
    cx: 27.225,
    cy: 27.225,
    r: 27.225,
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillOpacity: 0.2,
    d: "M27.225.453c14.956 0 27.099 12.07 27.225 27.007v-.218C54.45 12.214 42.253.017 27.225.017S0 12.197 0 27.225v.218C.126 12.523 12.269.453 27.225.453"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#212121",
    fillOpacity: 0.1,
    d: "M61.71 53.997H27.224C12.269 53.997.126 41.927 0 26.99v.218c0 15.028 12.197 27.225 27.225 27.225h34.484c10.02 0 18.152-8.133 18.152-18.152v-.218c-.129 9.93-8.205 17.934-18.152 17.934"
  }))), /*#__PURE__*/React.createElement("path", {
    fill: "url(#lighthouse_svg__u)",
    d: "M92.927 119.063h-8.821c-3.738-10.581-13.811-18.15-25.664-18.15-15.028 0-27.225 12.197-27.225 27.225s12.197 27.225 27.225 27.225h34.485c10.018 0 18.151-8.13 18.151-18.149s-8.133-18.151-18.151-18.151"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M127.777 1.335c70.35 0 127.397 56.846 127.761 127.108 0-.218.013-.435.013-.666C255.551 57.21 198.344 0 127.777 0S0 57.21 0 127.777c0 .217.015.435.015.666C.377 58.181 57.427 1.335 127.777 1.335"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M255.538 127.108c-.364 70.262-57.412 127.108-127.761 127.108-70.35 0-127.4-56.846-127.762-127.108 0 .233-.015.45-.015.669C0 198.344 57.21 255.55 127.777 255.55S255.55 198.344 255.55 127.777c0-.218-.013-.436-.013-.669"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 127.777,
    cy: 127.777,
    r: 127.777,
    fill: "url(#lighthouse_svg__m)"
  }))));
};
export default SvgLighthouse;